import React, { useState } from "react";
import DatePicker from "react-date-picker";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import TimePicker from 'react-time-picker';

import "./TrendContainer.scss";
import { connect } from "react-redux";
import { CHART_HEADER_CONST } from "../../common/constant/common-constants";
import { ChartTable } from "../../components/Table/Chart/ChartTable";

function TrendContainer(props) {

    const [selectedParamList, setSelectedParamList] = useState([]);
    const [duration, setDuration] = useState(null);
    const [trendDate, setTrendDate] = useState(null);
    const [trendStartTime, setTrendStartTime] = useState(null);
    const [trendEndTime, setTrendEndTime] = useState(null);
    const [interval, setInterval] = useState(null);
    const [headerList, setHeaderList] = useState(
        [CHART_HEADER_CONST.PARAMETERS, "08:00", "09:00", "10:00", "11:00", "12:00"]
    );

    const data = {
        "bedId": "1",
        "patientSessionId": 1,
        "date": "2022/07/01",
        "data": [
            {
                "id": 1,
                "time": "8:00",
                "hr": 61,
                "spo2": 62,
                "temp": 63,
                "rr": 60,
                "fio2": 61,
                "vti": 62,
                "vte": 63,
                "peep": 70,
                "pip": 65,
                "isUpdated": true
            },
            {
                "id": 2,
                "time": "9:00",
                "hr": 62,
                "spo2": 63,
                "temp": 64,
                "rr": 65,
                "fio2": 66,
                "vti": 67,
                "vte": 68,
                "peep": 70,
                "pip": 69,
                "isUpdated": false
            },
            {
                "id": 3,
                "time": "10:00",
                "hr": 62,
                "spo2": 63,
                "temp": 64,
                "rr": 65,
                "fio2": 66,
                "vti": 67,
                "vte": 68,
                "peep": 70,
                "pip": 69,
                "isUpdated": false
            },
            {
                "id": 4,
                "time": "11:00",
                "hr": 62,
                "spo2": 63,
                "temp": 64,
                "rr": 65,
                "fio2": 66,
                "vti": 67,
                "vte": 68,
                "peep": 70,
                "pip": 69,
                "isUpdated": false
            },
            {
                "id": 5,
                "time": "12:00",
                "hr": 62,
                "spo2": 63,
                "temp": 64,
                "rr": 65,
                "fio2": 66,
                "vti": 67,
                "vte": 68,
                "peep": 70,
                "pip": 69,
                "isUpdated": false
            }
        ]
    }

    const setParameter = (data) => {
        console.log("trend container param select :: " + JSON.stringify(data));
        setSelectedParamList(data);
    }

    const parameterOptionList = [
        { name: 'spo2', label: 'SPO2', id: "1" },
        { name: 'hr', label: 'HR', id: "2" },
        { name: 'temp', label: 'TEMP', id: "3" },
        { name: 'rr', label: 'RR', id: "4" },
        { name: 'fio2', label: 'FiO2', id: "5" },
        { name: 'vti', label: 'VTi', id: "6" },
        { name: 'vte', label: 'VTe', id: "7" },
        { name: 'peep', label: 'PEEP', id: "8" },
        { name: 'pip', label: 'PIP', id: "9" }
    ];

    const durationOptionList = [
        { name: '1H', label: '1H' },
        { name: '2H', label: '2H' },
        { name: '4H', label: '4H' },
        { name: '8H', label: '8H' }
    ];

    const intervalOptionList = [
        { name: '1H', label: '1H' },
        { name: '2H', label: '2H' },
        { name: '4H', label: '4H' },
        { name: '8H', label: '8H' }
    ]

    return (
        <div className="trend-container">
            <div className="generate-report-form">
                <div className="report-heading">
                    Generate Report
                </div>
                <div className="report-input-fields">
                    <div className="parameter-select-container form-input">
                        <div className="parameter label">Parameters</div>
                        <CustomSelect
                            className="parameter-name trend-input"
                            handleChange={(data) => setParameter(data)}
                            label='PARAMETER NAME'
                            options={parameterOptionList}
                            placeholder='Parameter Name'
                            isMulti={true}
                            components={{
                                IndicatorSeparator: () => null
                            }}
                        />
                    </div>
                    <div className="duration-select-container form-input">
                        <div className="duration label">Duration</div>
                        <CustomSelect
                            className="duration trend-input"
                            handleChange={(item) => setDuration(item)}
                            label='duration'
                            options={durationOptionList}
                            placeholder="Duration"
                            components={{
                                IndicatorSeparator: () => null
                            }}
                        />
                    </div>
                    <div className="trend-date-container form-input">
                        <div className="date label">Date</div>
                        <div className="date-container trend-input">
                            {/* <div className="date-text">Date: </div> */}
                            <DatePicker
                                className="trend-date"
                                onChange={(date) => setTrendDate(date)}
                                value={trendDate}
                            />
                        </div>
                    </div>
                    <div className="trend-time-container start-time form-input">
                        <div className="date label">Start Time</div>
                        <div className="time-container trend-input">
                            {/* <div className="date-text">Date: </div> */}
                            <TimePicker
                                className="trend-date"
                                onChange={(date) => setTrendStartTime(date)}
                                value={trendStartTime}
                            />
                        </div>
                    </div>
                    <div className="trend-time-container form-input">
                        <div className="date label">End Time</div>
                        <div className="time-container trend-input">
                            {/* <div className="date-text">Date: </div> */}
                            <TimePicker
                                className="trend-date"
                                onChange={(date) => setTrendEndTime(date)}
                                value={trendEndTime}
                            />
                        </div>
                    </div>
                    <div className="interval-select-container form-input">
                        <div className="interval label">Time Interval</div>
                        <CustomSelect
                            className="interval trend-input"
                            handleChange={(item) => setInterval(item)}
                            label='interval'
                            options={durationOptionList}
                            placeholder="Interval"
                            components={{
                                IndicatorSeparator: () => null
                            }}
                        />
                    </div>
                </div>
                <div className="submit-button-container">
                    <div className="submit-button">Generate Report</div>
                </div>
            </div>
            <div className="trend-data-container">
                <div className="trend-data-header">
                    <div className="report-text">Report</div>
                    <div className="download-button-container">
                        <div className="download-button">
                            Download
                        </div>
                    </div>
                </div>
                <div className="patient-details-container">
                    <div className="patient-details">
                        <div className="patient-name">
                            {(props.patientData && props.patientData.name) || 'Dummy Name'}
                        </div>
                        <div className="pipe">
                            |
                        </div>
                        <div className="patient-age">
                            {(props.patientData && props.patientData.age) || 'Age'}
                        </div>
                        <div className="pipe">
                            |
                        </div>
                        <div className="patient-gender">
                            {(props.patientData && props.patientData.gender) || 'Gender'}
                        </div>
                        <div className="pipe">
                            |
                        </div>
                        <div className="patient-uhid">
                            {(props.patientData && props.patientData.uhid) ?
                                (`UHID : ${props.patientData.uhid}`) : ('UHID : -')}
                        </div>
                    </div>
                </div>
                <div className="trend-table-container">
                    {selectedParamList && selectedParamList.length > 0 && <ChartTable
                        headerList={headerList}
                        parameterList={selectedParamList}
                        isEditable={false}
                        data={data}
                        handleDataChange={(...data) => console.log(data)}
                    />}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {

    let pData = state.patientDataReducer.patientData && state.patientDataReducer.patientData[ownProps.bedId];

    return {
        patientData: pData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrendContainer);